import React from 'react'
import { Divider } from '@material-ui/core'
import Fields from './Fields'

export default ({ inbox }) => (
  <div style={{ paddingTop: 7 }}>
    <Fields fieldType="email" />
    <Divider style={{ marginTop: 14, marginBottom: 7 }} />
    <Fields fieldType="phones" />
  </div>
)
